require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/es7.symbol.observable.js
// module id = 76
// module chunks = 0 1